import moment from 'moment'
import i18n from "src/lang";

export const TrackingType = {
  Transport: 1,
  Route: 2,
  ORDER: 3,
};

export const FILE_TYPES = {
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  XLS: "application/vnd.ms-excel",
  XLSM: "application/vnd.ms-excel.sheet.macroEnabled.12",
  PNG: "image/png",
  JPEG: "image/jpeg",
  JPG: "image/jpg",
  ZIP: "application/zip",
  XZIP: "application/x-zip-compressed",
  PDF: "application/pdf",
};

export const EXTENSIONS_BY_MIME = {
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/vnd.ms-excel": "xls",
  "application/vnd.ms-excel.sheet.macroenabled.12": "xlsm",
  "image/png": "png",
  "image/jpeg": "jpeg",
  "image/jpg": "jpg",
  "application/zip": "zip",
  "application/x-zip-compressed": "xzip",
  "application/pdf": "pdf",
};

export const STATUS = {
  PENDING: 2,
  ACTIVE: 1,
  INACTIVE: 0,
};
export const STATUS_STR = {
  2: "Pending",
  1: "Active",
  0: "Inactive",
};
export const ACTION_TYPE = {
  INSERT: { name: "Insert", value: 0 },
  EDIT: { name: "Edit", value: 1 },
};

export const MASTER_DATA = {
  DRIVER: {
    MAX_SIZE_PHOTO: 3,
  },
  RULES: {
    COMPANY_TAX_ID: "digits:13",
    COMPANY_NAME: "max:150",
    PHONE_CONCAT_NUMBER: "digits:11",
    PHONE_NUMBER: "digits:8",
    PHONE_NUMBER__KEYCONTACT: "digits:9",
    LANDLINE_EXTENSION: "max:8|numeric|onlyNumber",
    PERSON_NAME: `max:30|personName`,
    DRIVER_NAME: `max:30|driverName`,
    DRIVER_LICENSE_NUMBER: `min:1`,
  },
};

export const BUTTON_TYPES = {
  PRIMARY_OUTLINE: "primary_outline",
  PRIMARY: "primary",
};

export const MAX_SILE_IMPORT_SITE_FILE = 5 * Math.pow(1024, 2);

export const MAX_DRIVER_IMPORT_FILE = 1024 * Math.pow(1024, 2); // 1GB
export const ADDRESS_TYPES = {
  COUNTRY: "Country",
  PROVINCE: "Province",
  DISTRICT: "District",
  SUBDISTRICT: "Sub-District",
  POSTALCODE: "Postal Code",
};

export const ADDRESS_FORM_MODE = {
  CREATE: "Create",
  EDIT: "Edit",
};

export const CUSTOMER_RATE_CARD_SHEET_NAME = {
  TRIP: "Cust_RC_Trip",
  DISTANCE: "Cust_RC_Distance",
  WEIGHT: "Cust_RC_Weight",
  DIMENSIONAL_WEIGHT: "Cust_RC_Dimension Weight",
};

export const SUBCONTRACTOR_RATE_CARD_SHEET_NAME = {
  TRIP: "Sub_RC_Trip",
  DISTANCE: "Sub_RC_Distance",
  WEIGHT: "Sub_RC_Weight",
  DIMENSIONAL_WEIGHT: "Sub_RC_Dimension Weight",
};

export const RATE_CARD_TYPE = {
  BATH_PER_DISTANCE: "Baht/Distance",
  BATH_PER_TRIP: "Baht/Trip",
  BATH_PER_WEIGHT: "Baht/Weight",
  DIMENSIONAL_WEIGHT: "Baht/Dimension_Weight",
};

export const RATE_CARD_PRICE_COLUMN = [
  "15.00-15.99",
  "16.00-16.99",
  "17.00-17.99",
  "18.00-18.99",
  "19.00-19.99",
  "20.00-20.99",
  "21.00-21.99",
  "22.00-22.99",
  "23.00-23.99",
  "24.00-24.99",
  "25.00-25.99",
  "26.00-26.99",
  "27.00-27.99",
  "28.00-28.99",
  "29.00-29.99",
  "30.00-30.99",
  "31.00-31.99",
  "32.00-32.99",
  "33.00-33.99",
  "34.00-34.99",
  "35.00-35.99",
  "36.00-36.99",
  "37.00-37.99",
  "38.00-38.99",
  "39.00-39.99",
  "40.00-40.99",
];

export const CUSTOMER_RATE_CARD_TRIP_HEADER = [
  "Contract Code",
  "Company Name (TH)",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const CUSTOMER_RATE_CARD_DISTANCE_HEADER = [
  "Contract Code",
  "Company Name (TH)",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Distance (km)",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const CUSTOMER_RATE_CARD_WEIGHT_HEADER = [
  "Contract Code",
  "Company Name (TH)",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Weight (kg)",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const CUSTOMER_RATE_CARD_DIMENSIONAL_WEIGHT_HEADER = [
  "Contract Code",
  "Company Name (TH)",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Weight (kg)",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const SUBCONTRACTOR_RATE_CARD_TRIP_HEADER = [
  "Contract Code",
  "Company Registered Name",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const SUBCONTRACTOR_RATE_CARD_DISTANCE_HEADER = [
  "Contract Code",
  "Company Registered Name",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Distance (km)",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const SUBCONTRACTOR_RATE_CARD_WEIGHT_HEADER = [
  "Contract Code",
  "Company Registered Name",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Weight (kg)",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const SUBCONTRACTOR_RATE_CARD_DIMENSIONAL_WEIGHT_HEADER = [
  "Contract Code",
  "Company Registered Name",
  "Service Type",
  "Vehicle Type",
  "Effective Date",
  "End Date",
  "Origin",
  "Destination",
  "Weight (kg)",
  "Fuel Type",
  ...RATE_CARD_PRICE_COLUMN,
];

export const ACTIVITY_TRACKING_MENUS = {
  CANCEL: i18n.t("trackingActivity.cancel"),
  REASSIGN: i18n.t("trackingActivity.reassign"),
  DAMAGE: i18n.t("trackingActivity.damage"),
  LOST: i18n.t("trackingActivity.lost"),
  UPDATE_DRIVER: i18n.t("trackingActivity.updateStatus"),
};

export const ACTIVITY_TRACKING_STATUSES_MENU = {
  CANCEL: "cancel",
  REASSIGN: "re_assign",
  DAMAGE: "damaged",
  LOST: "lost",
  UPDATE_DRIVER: "update_driver",
};


export const ACTIVITY_TRACKING_ORDER_STATUSES = {
  order_created: "order_created",
  order_confirmed: "order_confirmed",
  order_processing: "order_processing",
  order_picking_up: "order_picking_up",
  order_ontheway: "order_ontheway",
  order_delivered: "order_delivered",
  order_approved: "order_approved",
  order_cancelled: "order_cancelled",
  order_pickup_failed: "order_pickup_failed",
  order_pending_delivery_fail: "order_pending_delivery_fail",
  order_returned: "order_returned",
  order_damaged: "order_damaged",
  order_lost: "order_lost",
};

export const ACTIVITY_TRACKING_JOB_STATUSES = {
  job_created: "job_created",
  job_planned: "job_planned",
  job_accepted: "job_accepted",
  job_arrive_origin: "job_arrive_origin",
  job_picking_up: "job_picking_up",
  job_ontheway: "job_ontheway",
  job_arrive_destination: "job_arrive_destination",
  job_handing_over: "job_handing_over",
  job_delivered: "job_delivered",
  job_approved: "job_approved",
  job_cancelled: "job_cancelled",
  job_pickup_failed: "job_pickup_failed",
  job_pending_delivery_fail: "job_pending_delivery_fail",
  job_delivery_failed: "job_delivery_failed",
  job_approved_return: "job_approved_return",
  job_returned: "job_returned",
  job_damaged: "job_damaged",
  job_lost: "job_lost",
};

export const ACTIVITY_TRACKING_SHIPMENT_STATUSES = { 
  shipment_created: "shipment_created",
  shipment_processing: "shipment_processing",
  shipment_dispatched: "shipment_dispatched",
  shipment_arrive_origin: "shipment_arrive_origin",
  shipment_ready_to_load: "shipment_ready_to_load",
  shipment_loading: "shipment_loading",
  shipment_ontheway: "shipment_ontheway",
  shipment_arrive_destination: "shipment_arrive_destination",
  shipment_ready_to_unload: "shipment_ready_to_unload",
  shipment_unloading: "shipment_unloading",
  shipment_delivered: "shipment_delivered",
  shipment_approved: "shipment_approved",
  shipment_cancelled: "shipment_cancelled",
  shipment_pickup_failed: "shipment_pickup_failed",
  shipment_pending_delivery_fail: "shipment_pending_delivery_fail",
  shipment_delivery_failed: "shipment_delivery_failed",
  shipment_approved_return:"shipment_approved_return",
  shipment_return_ontheway: "shipment_return_ontheway",
  shipment_return_arrive: "shipment_return_arrive",
  shipment_return_unloading: "shipment_return_unloading",
  shipment_returned: "shipment_returned",
  shipment_damaged: "shipment_damaged",
  shipment_lost: "shipment_lost",
};


function localizedActivityTrackingStatuses(sourceArray) {
  var array = JSON.parse(JSON.stringify(sourceArray))
  Object.keys(array).forEach(key => { 
    array[key] = i18n.t(`trackingActivity.${array[key]}`)
  })
  return array
}


export const ACTIVITY_TRACKING_STATUSES = {
  ...ACTIVITY_TRACKING_SHIPMENT_STATUSES,
  ...ACTIVITY_TRACKING_ORDER_STATUSES,
  ...ACTIVITY_TRACKING_JOB_STATUSES
};

//Localized statuses
export const ACTIVITY_TRACKING_SHIPMENT_STATUSES_LOCALIZED = localizedActivityTrackingStatuses(ACTIVITY_TRACKING_SHIPMENT_STATUSES)
export const ACTIVITY_TRACKING_ORDER_STATUSES_LOCALIZED = localizedActivityTrackingStatuses(ACTIVITY_TRACKING_ORDER_STATUSES)
export const ACTIVITY_TRACKING_JOB_STATUSES_LOCALIZED = localizedActivityTrackingStatuses(ACTIVITY_TRACKING_JOB_STATUSES)
export const ACTIVITY_TRACKING_STATUSES_LOCALIZED = {
  ...ACTIVITY_TRACKING_SHIPMENT_STATUSES_LOCALIZED,
  ...ACTIVITY_TRACKING_ORDER_STATUSES_LOCALIZED,
  ...ACTIVITY_TRACKING_JOB_STATUSES_LOCALIZED
}

//console.log("ACTIVITY_TRACKING_STATUSES: " + JSON.stringify(ACTIVITY_TRACKING_STATUSES, null, 4))
//console.log("ACTIVITY_TRACKING_STATUSES_LOCALIZED: " + JSON.stringify(ACTIVITY_TRACKING_STATUSES_LOCALIZED, null, 4))

export const ALLOW_RENDER_INFORMATION_BY_STATUS = {
  shipment_lost: ["reason", "remark"],
  shipment_damaged: ["reason", "remark"],
  shipment_pickup_failed: [
    "reason",
    "remark",
    "siteName",
    "siteCode",
    "actionBy",
    "location",
  ],
  shipment_cancelled: ["reason", "actionBy"],
  shipment_pending_delivery_fail: "all",
  shipment_delivery_failed: "all",
};

export const packingUnits = [
  {
    value: "Trip/001",
    label: i18n.t("business.trip1"),
  },
  {
    value: "Ton/002",
    label: i18n.t("business.ton2"),
  },
  {
    value: "Volume/003",
    label: i18n.t("business.volume3"),
  },
  {
    value: "Bag/004",
    label: i18n.t("business.bag4"),
  },
  {
    value: "Box/005",
    label: i18n.t("business.box5"),
  },
  {
    value: "Pack/006",
    label: i18n.t("business.pack6"),
  },
  {
    value: "Basket/007",
    label: i18n.t("business.basket7"),
  },
  {
    value: "Pallet/008",
    label: i18n.t("business.pallet8"),
  },
  {
    value: "Drop/009",
    label: i18n.t("business.drop9"),
  },
  {
    value: "Crate/010",
    label: i18n.t("business.crate10"),
  },
  {
    value: "Piece/011",
    label: i18n.t("business.piece11"),
  },
  {
    value: "Kg/012",
    label: i18n.t("business.kg12"),
  },
  {
    value: "Km/013",
    label: i18n.t("business.km13"),
  },
];

export const receiptType = [
  {
    label: i18n.t('public.all'),
    value: "All",
  },
  {
    label: i18n.t('public.pod'),
    value: "POD",
  },
  {
    label: i18n.t('public.epod'),
    value: "EPOD",
  },
];

export const Currencies = {
	THB: "THB",
	USD: "US Dollar",
}

export const currencyUnitType = [
  {
    label: i18n.t('business.thb'),
    value: Currencies.THB,
  },
  {
    label: "USD",//i18n.t('business.usDollar'),
    value: Currencies.USD,
  },
];

export function getSupportedCurrenciesList() {
  return currencyUnitType.filter(x => x.value == Currencies.THB)
}

export function getLocalizedCurrency(type) {
  const data = currencyUnitType.find((x) => x.value === type)
  if(data) {
    return data.label
  }
  return type || ''
}

export const DeliveryPaymentType = {
	Prepaid: "Prepaid",
	Postpaid: "Postpaid"
}


export const DeliveryPaymentChannel = {
  Cash: "Cash",
	TrueMoney: "TrueMoney",
	QRCode: "QR Code",
}

export const DeliveryPaymentChannelList = [
  {
    label: i18n.t('business.cash'),
    value: DeliveryPaymentChannel.Cash,
  },
  {
    label: i18n.t('business.trueMoney'),
    value: DeliveryPaymentChannel.TrueMoney,
  },
  {
    label: i18n.t('business.qrCode'),
    value: DeliveryPaymentChannel.QRCode,
  },
]

export const DeliveryPaymentStatusCode = {
	PROCESSING: "PROCESSING",
	SUCCESS: "SUCCESS",
	FAILED: "FAILED",
	WAIT_PAY: "WAIT_PAY",
  INPROGRESS: "INPROGRESS"
}

export const DisplayPaymentStatus = {
  [DeliveryPaymentStatusCode.SUCCESS]: "Success",
  [DeliveryPaymentStatusCode.INPROGRESS]: "In Progress",
  [DeliveryPaymentStatusCode.WAIT_PAY]: "Wait Pay",
  [DeliveryPaymentStatusCode.PROCESSING]: "Processing",
  [DeliveryPaymentStatusCode.FAILED]: "Failed"
}

export const BusinessType = {
	Midmile: "MIDMILE",
	Lastmile: "LASTMILE"
}

export function getPaymentStatus(paymentType, paymentStatus) {
  return DisplayPaymentStatus[paymentStatus] || "-"
}

export function mapChannelList(channels) {
  const array = channels || []
  const list = DeliveryPaymentChannelList
  return array.map(item => list.find(object => object.value == item)).filter(Boolean)
}

export function mapCurrencyList(currencies) {
  const array = currencies || []
  const list = currencyUnitType
  return array.map(item => list.find(object => object.value == item)).filter(Boolean)
}

export function defaultChannelsList() {
  return DeliveryPaymentChannelList
}

export function defaultCurrenciesList() {
  return currencyUnitType.filter(object => object.value == Currencies.THB)
}


export const DATA_CORRECT_FORM_FIELDS = {
  ROUTE_CODE: "routeCode",
  DO_REF: "doRef"
};
export const RETURN_ROADMAP = [
  {
    key: "shipment_approved_return",
    value: "Shipment _Approved_ Return",
    text: "Shipment_Approved_Return",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_return_ontheway",
    value: "Shipment _Return_ Ontheway",
    text: "Shipment_Return_Ontheway",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_return_arrive",
    value: "Shipment _Return_Arrive",
    text: "Shipment_Return_Arrive",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_return_unloading",
    value: "Shipment _Return_ Unloading",
    text: "Shipment_Return_Unloading",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_returned",
    value: "Shipment _Returned",
    text: "Shipment_Returned",
    active: false,
    ableToSelect: true,
  },
];
export const DEFAULT_ROADMAP = [
  {
    key: "shipment_created",
    value: "Shipment _Created",
    text: "Shipment_Created",
    active: false,
    ableToSelect: true,
  },

  {
    key: "shipment_processing",
    value: "Shipment _Processing",
    text: "Shipment_Processing",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_dispatched",
    value: "Shipment _Dispatched",
    text: "Shipment_Dispatched",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_arrive_origin",
    value: "Shipment_ Arrive_Origin",
    text: "Shipment_Arrive_Origin",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_ready_to_load",
    value: "Shipment _Ready_ To_Load",
    text: "Shipment_Ready_To_Load",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_loading",
    value: "Shipment _Loading",
    text: "Shipment_Loading",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_ontheway",
    value: "Shipment _Ontheway",
    text: "Shipment_Ontheway",
    active: false,
    ableToSelect: true,
  },

  {
    key: "shipment_arrive_destination",
    value: "Shipment _Arrive_ Destination",
    text: "Shipment_Arrive_Destination",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_ready_to_unload",
    value: "Shipment _Ready_ To_Unload",
    text: "Shipment_Ready_To_Unload",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_unloading",
    value: "Shipment _Unloading",
    text: "Shipment_Unloading",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_delivered",
    value: "Shipment _Delivered",
    text: "Shipment_Delivered",
    active: false,
    ableToSelect: true,
  },
  {
    key: "shipment_ontheway2",
    value: "Shipment _Ontheway",
    text: "Shipment_Ontheway",
    active: false,
    ableToSelect: false,
    show: false,
  },
  {
    key: "shipment_created2",
    value: "Shipment _Created",
    text: "Shipment_Created",
    active: false,
    ableToSelect: false,
    show: false,
  },
  {
    key: "shipment_processing2",
    value: "Shipment _Processing",
    text: "Shipment_Processing",
    active: false,
    ableToSelect: false,
    show: false,
  },
];

export const DEFAULT_CARDS = {
  shipment_dispatched: {
    title: "Shipment_Dispatched",
    active: false,
    formFields: {
      shipment_dispatched_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.arriveOriginDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        hidden: true,
      },
    },
  },
  shipment_arrive_origin: {
    title: "Shipment_Arrive_Origin",
    active: false,
    formFields: {
      shipment_arrive_origin_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.arriveOriginDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        value: "",
        rules: "required",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_ready_to_load: {
    title: "Shipment_Ready_To_Load",
    active: false,
    skipStatus: false,
    showSkipButton: true,
    formFields: {
      shipment_ready_to_load_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.readyToLoadDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        hidden: false,
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_loading: {
    title: "Shipment_Loading",
    active: false,
    formFields: {
      shipment_loading_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.loadingDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_ontheway: {
    title: "Shipment_Ontheway",
    active: false,
    formFields: {
      shipment_ontheway_time: {
        label: `<span class='text-danger'>*</span><span>${i18n.t('trackingActivity.onTheWayDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      whiteSpace: {
        label: "<span>&ensp;</span>",
        component: "BaseExtraText",
        className: "col-span-8",
        value: "",
      },
      weight: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.pickedUpWeightKg')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterPickedUpWeight'),
        noRequiredLength: true,
        immediate: true,
      },
      actualQuantityOfPackages: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualNoOfPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualNoOfPackage'),
        noRequiredLength: true,
        immediate: true,
      },
      actualQuantityOfGoods: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualNoOfItemPerPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualNoOfItemPerPackage'),
        noRequiredLength: true,
        immediate: true,
      },
      volume: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualVolumeCM')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualVolume'),
        noRequiredLength: true,
        immediate: true,
      },
      temperature: {
        label: `<span>${i18n.t('trackingActivity.goodTemp')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "cusNumericShipmentStatus|betweenShipmentStatus:-100,100",
        value: "",
        placeholder: i18n.t('trackingActivity.enterTemp'),
        noRequiredLength: true,
      },
      whiteSpace0: {
        label: "<span>&ensp;</span>",
        component: "BaseExtraText",
        className: "col-span-8",
        value: "",
      },
      uploadImage: {
        label: `${i18n.t('public.uploadImage')} (0/30) <span class='text-secondary-45'>${i18n.t('public.imageFormatSize', {x: MASTER_DATA.DRIVER.MAX_SIZE_PHOTO})}</span>`,
        component: "BaseUploadMultiplePhoto",
        value: "",
        className: "col-span-12 pb-4",
        maxFileSize: MASTER_DATA.DRIVER.MAX_SIZE_PHOTO,
        rules: "",
        validFileTypes: [
          FILE_TYPES.PDF,
          FILE_TYPES.PNG,
          FILE_TYPES.JPEG,
          FILE_TYPES.JPEG,
        ],
        photoFileType: ".pdf, .jpg, .jpeg, .png",
        images: [],
        isComponent: "shipment_ontheway",
      },
    },
  },
  shipment_arrive_destination: {
    title: "Shipment_Arrive_Destination",
    active: false,
    formFields: {
      shipment_arrive_destination_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.arrivalDestinationDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_ready_to_unload: {
    title: "Shipment_Ready_To_Unload",
    active: false,
    skipStatus: false,
    showSkipButton: true,
    formFields: {
      shipment_ready_to_unload_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.readyToUnloadDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        hidden: false,
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_unloading: {
    title: "Shipment_Unloading",
    active: false,
    formFields: {
      shipment_unloading_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.unloadingDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_delivered: {
    title: "Shipment_Delivered",
    active: false,
    formFields: {
      shipment_delivered_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.deliveredDateTime')}</span>`,
        className: "col-span-3",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      shipmentDeliverTemperature: {
        label: `<span>${i18n.t('trackingActivity.goodTemp')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "cusNumericShipmentStatus|betweenShipmentStatus:-100,100",
        value: "",
        placeholder: i18n.t('trackingActivity.enterTemp'),
        noRequiredLength: true,
      },
      whiteSpace1: {
        label: "<span>&ensp;</span>",
        component: "BaseExtraText",
        className: "col-span-6",
        value: "",
      },
      deliverWeight: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.deliverWeightKg')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterDeliverWeight'),
        noRequiredLength: true,
        immediate: true,
      },
      actualQuantityOfPackages: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualNoOfPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualNoOfPackage'),
        noRequiredLength: true,
        immediate: true,
      },
      actualQuantityOfGoods: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualNoOfItemPerPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualNoOfItemPerPackage'),
        noRequiredLength: true,
        immediate: true,
      },
      volume: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualVolume')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualVolume'),
        noRequiredLength: true,
        immediate: true,
      },

      damagedQuantity: {
        label: `<span>${i18n.t('public.damagedItem')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('public.enterDamagedItem'),
        noRequiredLength: true,
        immediate: true,
      },
      damagedPackage: {
        label: `<span>${i18n.t('public.damagedPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('public.enterDamagedPackage'),
        noRequiredLength: true,
        immediate: true,
      },
      rejectedQuantity: {
        label: `<span>${i18n.t('public.rejectedItem')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('public.enterRejectedItem'),
        noRequiredLength: true,
        immediate: true,
      },
      rejectedPackage: {
        label: `<span>${i18n.t('public.rejectedPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('public.enterRejectedPackage'),
        noRequiredLength: true,
        immediate: true,
      },

      lostQuantity: {
        label: `<span>${i18n.t('public.lostItem')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        value: "",
        placeholder: i18n.t('public.enterLostItem'),
        noRequiredLength: true,
        disabled: true
      },
      lostPackage: {
        label: `<span>${i18n.t('public.lostPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        value: "",
        placeholder: i18n.t('public.enterLostPackage'),
        noRequiredLength: true,
        disabled: true
      },
      whiteSpace: {
        label: "<span>&ensp;</span>",
        component: "BaseExtraText",
        className: "col-span-6",
        value: "",
      },

      paymentChannel: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.paymentChannel')}</span>`,
        className: "col-span-3",
        component: "BaseSelect",
        rules: "required",
        value: "",
        placeholder: i18n.t('trackingActivity.enterPaymentChannel'),
        noRequiredLength: true,
        disabled: false,
        hideDetails: false,
        immediate: true,
        itemText: "label",
        itemValue: "value",
        options: [] //set from UpdateStatusDialog.vue
      },
      actualOrderPrice: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.actualOrderPrice')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules: "required|decimal:2|betweenMinMax:0,10000000",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualOrderPrice'),
        immediate: true,
        noRequiredLength: true,
      },
      actualCurrency: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.actualCurrency')}</span>`,
        className: "col-span-3",
        component: "BaseSelect",
        rules: "required",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualCurrency'),
        noRequiredLength: true,
        disabled: false,
        hideDetails: false,
        immediate: true,
        itemText: "label",
        itemValue: "value",
        options: [] //set from UpdateStatusDialog.vue
      },

      uploadImage: {
        label: `${i18n.t('public.uploadImage')} (0/30) <span class='text-secondary-45'>${i18n.t('public.imageFormat')}</span>`,
        component: "BaseUploadMultiplePhoto",
        value: "",
        className: "col-span-12 pb-4",
        maxFileSize: MASTER_DATA.DRIVER.MAX_SIZE_PHOTO,
        rules: "",
        validFileTypes: [
          FILE_TYPES.PDF,
          FILE_TYPES.PNG,
          FILE_TYPES.JPEG,
          FILE_TYPES.JPEG,
        ],
        photoFileType: ".pdf, .jpg, .jpeg, .png",
        images: [],
        isComponent: "shipment_delivered",
      },
    },
  },
  shipment_delivery_failed: {
    title: "Shipment_Delivery_Fail",
    active: false,
    formFields: {
      shipment_delivery_failed_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.damagedDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      reason: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.reason')}</span>`,
        className: "col-span-12",
        component: "BaseTextArea",
        rules: "max:250",
        value: "",
        placeholder: i18n.t('public.enterReason'),
        height: 104,
      },
    },
  },
  shipment_return_ontheway: {
    title: "Shipment_Return_Ontheway",
    active: false,
    formFields: {
      shipment_return_ontheway_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.returnOnthewayDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  // shipment_return_departed: {
  //   title: "Shipment_Return_Departed",
  //   active: false,
  //   formFields: {
  //     shipment_return_ontheway_time: {
  //       label: `<span class='text-danger'>*</span> <span>Return Departed Date and Time</span>`,
  //       className: "col-span-4",
  //       component: "BaseDateTimePicker",
  //       rules: "required",
  //       value: "",
  //       placeholder: i18n.t('public.selectDateTime'),
  //       format: "yyyy-MM-DD",
  //       max: moment(),
  //       autoUpdateMax: true,
  //       isValid: false,
  //     },
  //   },
  // },
  shipment_return_arrive: {
    title: "Shipment_Return_Arrive",
    active: false,
    formFields: {
      shipment_return_arrive_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.returnArriveDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_return_unloading: {
    title: "Shipment_Return_Unloading",
    active: false,
    formFields: {
      shipment_return_unloading_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.returnUnloadingDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
    },
  },
  shipment_returned: {
    title: "Shipment_Returned",
    active: false,
    formFields: {
      shipment_returned_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.returnedDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      whiteSpace: {
        label: "<span>&ensp;</span>",
        component: "BaseExtraText",
        className: "col-span-6",
        value: "",
      },
      actualQuantityOfPackages: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualNoOfPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules:
          "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualNoOfPackage'),
        noRequiredLength: true,
        immediate: true,
      },
      actualQuantityOfGoods: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.actualNoOfItemPerPackage')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules:
          "required|cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterActualNoOfItemPerPackage'),
        noRequiredLength: true,
        immediate: true,
      },
      shipmentReturnTemperature: {
        label: `<span>${i18n.t('trackingActivity.shipmentReturnTemp')}</span>`,
        className: "col-span-3",
        component: "BaseInput",
        rules:
          "cusNumericShipmentStatus|betweenShipmentStatus:0,999999",
        value: "",
        placeholder: i18n.t('trackingActivity.enterTemp'),
        noRequiredLength: true,
      },
      uploadImage: {
        label: `${i18n.t('public.uploadImage')} (0/30) <span class='text-secondary-45'>${i18n.t('public.imageFormat')}</span>`,
        component: "BaseUploadMultiplePhoto",
        value: "",
        className: "col-span-12 pb-4",
        maxFileSize: MASTER_DATA.DRIVER.MAX_SIZE_PHOTO,
        rules: "",
        validFileTypes: [
          FILE_TYPES.PDF,
          FILE_TYPES.PNG,
          FILE_TYPES.JPEG,
          FILE_TYPES.JPEG,
        ],
        photoFileType: ".pdf, .jpg, .jpeg, .png",
        images: [],
        isComponent: "shipment_returned",
      },
    },
  },
  shipment_pickup_failed: {
    title: "Shipment_PickUp_Failed",
    active: false,
    formFields: {
      shipment_pickup_failed_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.pickupFailedDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      reason: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.reason')}</span>`,
        className: "col-span-12",
        component: "BaseTextArea",
        rules: "required|max:250",
        value: "",
        placeholder: i18n.t('public.enterReason'),
        height: 104,
      },
      cancelled: {},
    },
  },
  shipment_pending_delivery_fail: {
    title: "Shipment_Pending_Delivery_Fail",
    active: false,
    formFields: {
      shipment_pending_delivery_fail_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.pendingDeliveryFailDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      reason: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.reason')}</span>`,
        className: "col-span-12",
        component: "BaseTextArea",
        rules: "required|max:250",
        value: "",
        placeholder: i18n.t('public.enterReason'),
        height: 104,
      },
      destination: {
        label: i18n.t('trackingActivity.destination'),
        className: "col-span-12",
        value: null,
        component: "BaseSiteDataCard",
        rules: "",
        btnDisabled: false,
      },
      action: {},
    },
  },
  shipment_damaged: {
    title: "Shipment_Damaged",
    active: false,
    formFields: {
      shipment_damaged_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.damagedDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      reason: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.reason')}</span>`,
        className: "col-span-12",
        component: "BaseTextArea",
        rules: "required|max:250",
        value: "",
        placeholder: i18n.t('public.enterReason'),
        height: 104,
      },
    },
  },
  shipment_lost: {
    title: "Shipment_Lost",
    active: false,
    formFields: {
      shipment_lost_time: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('trackingActivity.lostDateTime')}</span>`,
        className: "col-span-4",
        component: "BaseDateTimePicker",
        rules: "required",
        value: "",
        placeholder: i18n.t('public.selectDateTime'),
        format: "yyyy-MM-DD",
        max: moment(),
        autoUpdateMax: true,
        isValid: false,
      },
      reason: {
        label: `<span class='text-danger'>*</span> <span>${i18n.t('public.reason')}</span>`,
        className: "col-span-12",
        component: "BaseTextArea",
        rules: "required|max:250",
        value: "",
        placeholder: i18n.t('public.enterReason'),
        height: 104,
      },
    },
  },
};

export const SHIPMENT_STATUS_DISPLAY_MILEAGE = ['SHIPMENT_DELIVERED', 'SHIPMENT_DELIVERY_FAILED', 'SHIPMENT_DAMAGED', 'SHIPMENT_LOST','SHIPMENT_RETURNED'];
export const JOB_STATUS_DISPLAY_MILEAGE = ['JOB_DELIVERED', 'JOB_DELIVERY_FAILED', 'JOB_DAMAGED', 'JOB_LOST', 'JOB_RETURNED'];



// WEBPACK FOOTER //
// ./src/utils/CONSTANT.js